import React from 'react'
import { Link as RRLink } from 'react-router-dom'
import styled from 'styled-components'
import { Box } from '@ally/metronome-ui'
import { asCurrency } from '@ally/aos-utils'
import MobileWealthCardDetail from './MobileWealthCardDetail'
import { STALE_DATA_COPY } from '../../../constants'
import { getDashDash } from '../../../utils'

const StyledAnchor = styled(RRLink)(({ theme }) => theme.buttons.link)

const StyledLink = styled(StyledAnchor)`
  width: 100%;
`

const TotalAvailableBalance: React.FC<{
  totalValue: number
  hasStaleData: boolean
}> = ({ totalValue, hasStaleData }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      borderLeftStyle="solid"
      borderLeftWidth="7px"
      py="sm"
      px="xs"
      borderTop="1px solid"
      borderTopColor="slate-2"
      width="100%"
      borderBottom="1px solid"
      borderBottomColor="slate-2"
      borderRadius="0 0 4px 4px"
    >
      <Box fontWeight="bold">Total</Box>
      <Box fontWeight="bold">
        {hasStaleData ? getDashDash(STALE_DATA_COPY) : asCurrency(totalValue)}
      </Box>
    </Box>
  )
}

const MobileWealthClient: React.FC<{
  hasOnlyClosedAccounts: boolean
  totalValue: number
  hasStaleData: boolean
}> = ({ hasOnlyClosedAccounts, totalValue, hasStaleData }) => {
  const content = (
    <MobileWealthCardDetail
      hasOnlyClosedAccounts={hasOnlyClosedAccounts}
      totalValue={totalValue}
      hasStaleData={hasStaleData}
    />
  )
  return (
    <>
      <StyledLink
        to="/ext-wealth/wealth-overview"
        aria-label="Wealth Overview"
        data-allytmln="wealth-wealthOverview"
      >
        {content}
      </StyledLink>
      {!hasOnlyClosedAccounts && (
        <TotalAvailableBalance
          totalValue={totalValue}
          hasStaleData={hasStaleData}
        />
      )}
    </>
  )
}

export default MobileWealthClient
